import React, { FC, useState } from 'react';

import { ProductAttributes, ProductDescription, ProductDocuments } from 'app/products';
import { IGood } from 'entities/products';

import { Icon } from '@nebo-team-dev/vobaza.ui.icon';

import styles from './styles.module.scss';

type Props = {
  product: IGood;
};

const MobileOptions: FC<Props> = ({ product }) => {
  const [collapseDesc, setCollapseDesc] = useState(true);
  const [collapseOption, setCollapseOption] = useState(product.description_full ? false : true);

  const [collapseFullDesc, setCollapseFullDesc] = useState(false);
  const description = collapseFullDesc ? product?.description_full : product?.description_full?.slice(0, 400);

  const descriptionHandler = () => {
    setCollapseOption(false);
    setCollapseDesc(true);
  };

  const optionHandler = () => {
    setCollapseDesc(false);
    setCollapseOption(true);
  };

  return (
    <div className={styles.optionsContainer}>
      <div className={styles.optionsLabels}>
        {product.description_full && (
          <div className={collapseDesc === true ? styles.active : styles.optionLabel} onClick={descriptionHandler}>
            Описание
          </div>
        )}
        <div className={collapseOption === true ? styles.active : styles.optionLabel} onClick={optionHandler}>
          Характеристики
        </div>
      </div>
      <div className={styles.optionInfo}>
        {collapseOption && (
          <ProductAttributes
            attributes={product.attributes}
            weight={product.product_weight || null}
            assembly={product.assembly}
          />
        )}
        {collapseDesc && (
          <div style={product.description_full ? { display: 'block' } : { display: 'none' }}>
            {description && <ProductDescription html={description} />}
            {product.description_full?.length > 400 && (
              <button onClick={() => setCollapseFullDesc(!collapseFullDesc)} className={styles.showMoreButton}>
                {!collapseFullDesc ? 'Показать полностью' : 'Скрыть описание'}
                {!collapseFullDesc ? <Icon name="SmallArrowDown" /> : <Icon name="SmallArrowUp" />}
              </button>
            )}
          </div>
        )}
        <div className={styles.productDocuments}>
          {product.documents && <ProductDocuments documents={product.documents} />}
        </div>
      </div>
    </div>
  );
};

export { MobileOptions };
